/* Built In Imports */
import React, { useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import Breadcrum from '@components/Navigation/Breadcrum';
import EventsCommonUI from '@components/UI/Events/EventsCommonUI';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';

/* Services */
import {
    getLocale
} from '@components/Utility/Shared/SharedService';
import {
    fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData, filterBuildUrls,
    getLatestBuild
} from 'services/commonService';
import { fetchDetails } from 'services/nagapratishthaService';
import { BuildConstants } from '../../../../../../constants';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Events Landing Page Data
 */
const Nagapratishta = ({ region, language, pageData }) => {
  useEffect(() => {
    window.$crisp = [];
    window.CRISP_WEBSITE_ID = '5a3a8acc-1324-4b61-a20a-9ba06282968a';

    (function () {
      let d = document;
      let s = d.createElement('script');

      s.src = 'https://client.crisp.chat/l.js';
      s.async = 1;
      d.getElementsByTagName('head')[0].appendChild(s);
    })();
    setTimeout(() => {
      $crisp.push(['set', 'session:data', [['program', 'naga-consecration']]]);
    }, 2000);
  });
  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      ></HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <Box as="section" maxW="1300px" mx="auto">
        <EventsCommonUI
          pageBody={pageData.body}
          region={region}
          lang={language}
        />
      </Box>
    </WrapLayout>
  );
};

export const getStaticPaths = async () => {
  let nagapratishtaLandingPaths =
    config.USE_LOCAL_URL || config.BUILD_URLS?.LANDING_PAGES?.Nagapratishta
      ? ['/us/en/events/special-events/naga-pratishtha']
      : [];

  if (process.env?.NEXT_PUBLIC_BUILD_ID) {
    let data = await getLatestBuild(process.env.NEXT_PUBLIC_BUILD_ID);
    nagapratishtaLandingPaths = filterBuildUrls(
      `${BuildConstants.section.landing_pages}`,
      `${BuildConstants.level.L2}`,
      '/events/special-events/naga-pratishtha',
      '',
      data
    );
  }
  return {
    paths: nagapratishtaLandingPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, language },
  req,
}) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchDetails(region, language);
  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: region,
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Nagapratishta',
    },
  };
};

export default Nagapratishta;
